export const useStoreStream = defineStore('StoreStream', {
    state: () => ({
        stream: null,
        viewers: null,
        viewerPollerId: null,
        error: null,
    }),
    actions: {
        async getStream (streamSlug) {
            this.error = null;
            this.stream = null;
            ({stream: this.stream, error: this.error} = await useEntityStream().get(streamSlug));
            await this.getStreamViewers();
        },
        async getStreamViewers () {
            if (!this.stream) return;
            ({viewers: this.viewers} = await useEntityStreamViewers().get(this.stream?.stream_slug));
        },
        async startLiveStreamViewersPoller () {
            await this.stopLiveStreamViewersPoller();
            this.viewerPollerId = setInterval(this.getStreamViewers, 10000);
        },
        async stopLiveStreamViewersPoller () {
            if (this.viewerPollerId) clearInterval(this.viewerPollerId);
            this.viewerPollerId = null;
        },
        refreshStream () {
            const $config = useRuntimeConfig();
            if ($config.public.stage === 'dev') console.log('Refreshing stream...');
            if (this.stream && this.stream?.id_stream_play && this.stream?.stream_slug) this.getStream(this.stream?.stream_slug);
        },
    },
});
